import { ArrowCircleUpSharp } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import alertService from "../../services/alertService";
import { blueGradientBackground } from "../../shared/colours";
import { cardStyle } from "../../shared/Theme";
import userService from "../../services/userService";
import reportService from "../../services/reportService";
import companyService from "../../services/companyService";
import VscanModal from "./VscanModal";

const CardVulnerabilityScanReports = (props) => {

	let [ showModal, setShowModal ] = useState(false);
	
	const handleTitleClick = () => {
		setShowModal(true);
	};
	
	const handleModalClose = () => {
		setShowModal(false);
	};
	
	return (
		<React.Fragment>
			<Stack
				direction="column"
				onClick={handleTitleClick}
				sx={{ ...cardStyle, width: "28em", height: "16em", '&:hover': { cursor: "pointer" } }}
			>
				<Typography
					variant="h5"
					sx={{
						width: "100%",
						textAlign: "center",
						marginTop: "1em",
						cursor: "pointer",
						fontWeight: "bold",
						marginTop: "2em"
					}}
				>
					Vulnerability Scan Reports
				</Typography>
				<Box sx={{ width: "12em", margin: "3em auto" }}>
					<Stack
						direction="row"
						sx={{
							width: "100%",
							height: "3.5em",
							borderRadius: "2.5em",
							background: blueGradientBackground,
							"&:hover": {
								cursor: "pointer"
							}
						}}
						alignItems="center"
						justifyContent="center"
						spacing={0.5}
					>
						<Typography
							sx={{
								fontWeight: "bold",
								color: "#ffffff",
								paddingLeft: "0.5em",
								fontSize: "1em",
							}}
						>
							Access Reports
						</Typography>
						<ArrowCircleUpSharp
							sx={{
								width: "2.4em",
								height: "2.4em",
								transform: "rotate(90deg)",
								color: "#ffffff"
							}}
						/>
					</Stack>
				</Box>
			</Stack>
			<VscanModal show={showModal} onClose={handleModalClose}/>
		</React.Fragment>
	);

}

export default CardVulnerabilityScanReports;